import { Component, Input } from '@angular/core';

@Component({
  selector: 'sd-trend-icon',
  templateUrl: './trend-icon.component.html',
  styleUrls: ['./trend-icon.component.scss']
})
export class TrendIconComponent {
  @Input() value: number;
  @Input() displayValue: string;
  @Input() inverted = false;
  @Input() size = '1.1em'; // Optional inline size control
  @Input() showValue = true; // Whether to show the displayValue along with the icon
  @Input() primary = false; // Whether this is a primary metric (affects styling)

  isTrendUp(): boolean | null {
    if (this.value === 0 || this.value === undefined || this.value === null) {
      return null;
    }

    return this.value > 0
      ? !this.inverted
      : this.inverted;
  }

  getArrowClass(): string {
    const trend = this.value;
    const isUp = this.isTrendUp();

    if (isUp === null || trend === 0) {
      return 'fa fa-horizontal-rule';
    } else if (trend > 0) {
      return 'fa fa-chevron-circle-up chevron-icon';
    } else {
      return 'fa fa-chevron-circle-down chevron-icon';
    }
  }

  getBgColorClass(): string {
    const isUp = this.isTrendUp();

    if (isUp === null) return 'bg-yellow';
    return isUp ? 'bg-green' : 'bg-red';
  }

  getTextColorClass(): string {
    const isUp = this.isTrendUp();

    if (isUp == null) return '';
    return isUp ? 'text-green' : 'text-red';
  }
}
